module.exports = __webpack_public_path__ + "img/1 (131).25286a03.png";